// extracted by mini-css-extract-plugin
export default {"UploadBtn":"FileUploaderBeta_UploadBtn__aJfq1","UploadBtn--large":"FileUploaderBeta_UploadBtn--large__jrSzY","UploadBtn--disabled":"FileUploaderBeta_UploadBtn--disabled__YcR2f"};